import { Fragment, forwardRef } from 'react';
import { Theme } from '../../types/enums';
import Tab from './Tab/Tab';

import { SelectorType, TabDesign, TabLayout } from './types/enums';
import { SortAndFilterPropType, TabData, TabsProps, TabsTheme } from './types/propType';
import styles from './Tabs.module.scss';

const Tabs = forwardRef<HTMLDivElement, TabsProps>(
  (
    {
      selectorType = SelectorType.UNDERLINE,
      tabList,
      theme = Theme.BLACK,
      selectedTab = 0,
      layout = TabLayout.HORIZONTAL,
      design = TabDesign.THEMED,
      sortAndFilter = false,
      onTabClick,
      sortAndFilterCount = '',
      className,
    }: TabsProps,
    ref,
  ) => {
    function handleClick(index: number, id?: string) {
      id ? onTabClick?.(index, id) : onTabClick?.(index);
    }
    const {
      title = 'Sort & Filter',
      count = sortAndFilterCount,
      selected: sortAndFilterSelected,
    } = sortAndFilter as SortAndFilterPropType;
    return (
      <div
        className={`
        ${styles['tabs-container']} 
        ${styles[design === TabDesign.DEFAULT ? 'white' : design]} 
        ${styles[theme]} 
        ${styles[`selector-${selectorType}`]} 
        ${styles[`layout-${layout}`]} 
        ${className}
      `}
        ref={ref}
      >
        {sortAndFilter && (
          <span className={styles['tab-sort-filter']}>
            <Tab
              theme={theme}
              selectorType={SelectorType.CIRCLE}
              title={title}
              layout={TabLayout.HORIZONTAL}
              design={TabDesign.PILL}
              icon={'sliders'}
              selected={sortAndFilterSelected ?? selectedTab === 0}
              onTabClick={() => onTabClick?.(0, 'sortFilter')}
              className={styles['tab-sort-filter-content']}
              data-testid="tab-sortAndFilter-testid"
            />
            {count && <div className={styles['tab-sort-filter-badge']}>{count}</div>}
          </span>
        )}
        {sortAndFilter && <div className={styles['tab-divider']} data-testid={'tab-divider-testid'}></div>}
        {tabList.map(({ title, icon, iconStyle, id, divider, disabled, dataTabScrollId, tabTheme = theme }, index) => {
          const ind = sortAndFilter ? index + 1 : index;
          return (
            <Fragment key={`${id || ''}-${index + 1}`}>
              <div>
                <Tab
                  theme={tabTheme}
                  selectorType={selectorType}
                  title={title}
                  layout={layout}
                  design={design}
                  icon={icon}
                  iconStyle={iconStyle}
                  selected={selectedTab === ind}
                  onTabClick={() => {
                    handleClick(ind, id);
                  }}
                  disabled={disabled}
                  dataTabScrollId={dataTabScrollId}
                />
              </div>
              {divider && <div className={styles['tab-divider']}></div>}
            </Fragment>
          );
        })}
      </div>
    );
  },
);
Tabs.displayName = 'Tabs';

export { SelectorType, TabLayout, TabDesign, Tab };
export type { TabData, TabsProps, TabsTheme, SortAndFilterPropType };
export default Tabs;
